import { useState } from 'react';
import type { InputHTMLAttributes } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

/** Password `<input>` with a show/hide toggle. Accepts all standard input props except `type`. */
export function PasswordInput(props: Props) {
  const [revealed, setRevealed] = useState(false);
  const { className = 'form-input', style, ...rest } = props;
  return (
    <div style={{ position: 'relative', ...style }}>
      <input
        {...rest}
        type={revealed ? 'text' : 'password'}
        className={className}
        style={{ paddingRight: 56, width: '100%' }}
      />
      <button
        type="button"
        onClick={() => setRevealed((v) => !v)}
        aria-label={revealed ? 'hide password' : 'show password'}
        style={{
          position: 'absolute',
          right: 8,
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'transparent',
          border: 'none',
          color: 'var(--color-muted)',
          fontFamily: 'var(--font-mono)',
          fontSize: 'var(--font-size-sm)',
          cursor: 'pointer',
          padding: '2px 4px',
        }}
      >
        [{revealed ? 'hide' : 'show'}]
      </button>
    </div>
  );
}
